module.exports = __webpack_public_path__ + "static/img/Gillon.McLachlan.b4b5f0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Gillon.McLachlan.jpg
// module id = ZeaD
// module chunks = 0